import { useTranslation } from 'react-i18next'
import cx from 'classnames'

import { useIsWorldCoinEnable } from 'hooks'
import { useSNSAuthentication } from 'features/SNS/useSNS'
import { useBannerRemoteConfig } from 'features/RemoteConfig/useBannerRemoteConfig'

type Props = {
  className?: string
}

export const LoginMethod = ({ className }: Props) => {
  const banner = useBannerRemoteConfig()
  const { t } = useTranslation()

  const isWorldCoinEnable = useIsWorldCoinEnable()
  const isFacebookLoginDisabled = banner?.data?.is_facebook_login_broken
  const {
    onLineClick,
    onTwitterClick,
    onFacebookClick,
    onAppleClick,
    onGoogleClick,
    onWorldcoinClick,
  } = useSNSAuthentication()

  return (
    <div className={cx('LoginMethods', className)}>
      {[
        {
          label: 'LINE',
          onClick: onLineClick,
          icon: '/images/icon-logo-line.svg',
        },
        {
          label: 'Google',
          onClick: onGoogleClick,
          icon: '/images/icon-logo-google.svg',
        },
        {
          label: 'Apple ID',
          onClick: onAppleClick,
          icon: '/images/icon-logo-apple.svg',
        },
        {
          label: 'X',
          onClick: onTwitterClick,
          icon: '/images/icon-logo-x.svg',
        },
        ...(!isFacebookLoginDisabled
          ? [
              {
                label: 'Facebook',
                onClick: onFacebookClick,
                icon: '/images/icon-logo-facebook.svg',
              },
            ]
          : []),
        ...(isWorldCoinEnable
          ? [
              {
                label: 'World ID',
                onClick: onWorldcoinClick,
                icon: '/images/icon-logo-worldcoin.svg',
              },
            ]
          : []),
      ].map((x) => (
        <a key={x.label} className="LoginMethods__a" onClick={x.onClick}>
          <img className="LoginMethods__a__img" src={x.icon} />
          <p>
            {t('common.continue_with', {
              provider: x.label,
            })}
          </p>
        </a>
      ))}
    </div>
  )
}
